import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const BoosterSeatIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className} `;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="booster-seat-icon"
      viewBox="0 0 17 16"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9416 1.33398L12.0083 10.5423C11.7583 12.1923 10.2999 13.434 8.61659 13.434H1.83325V14.6673H8.60825C10.9333 14.6673 12.8833 13.009 13.2499 10.709L15.1666 1.33398H13.9416ZM9.22491 12.184H4.64158C4.52652 12.184 4.43325 12.2773 4.43325 12.3923V12.809C4.43325 12.9241 4.52652 13.0173 4.64158 13.0173H9.22491C9.33997 13.0173 9.43325 12.9241 9.43325 12.809V12.3923C9.43325 12.2773 9.33997 12.184 9.22491 12.184ZM9.55827 11.7173H3.62493V11.709C3.4666 11.709 3.3416 11.5673 3.3666 11.409C3.78327 8.9923 5.85827 9.15896 6.93327 9.4173H6.94993C7.02217 9.43656 7.08885 9.45582 7.14995 9.47348C7.19458 9.48637 7.23624 9.49841 7.27493 9.50896C7.37383 9.53468 7.47931 9.56555 7.59481 9.59937C7.96591 9.70801 8.44054 9.84696 9.13327 9.9423C9.13631 9.9423 9.14605 9.94257 9.16018 9.94298C9.22332 9.94479 9.37422 9.9491 9.40827 9.9423C9.85827 9.90063 9.98327 9.57563 10.0166 9.40896C10.0249 9.35896 10.0249 9.30896 10.0249 9.25896C9.95827 8.43396 8.9916 8.72563 8.9916 8.72563C8.75827 8.78396 8.57493 8.8173 8.4166 8.8173C7.70827 8.83396 7.67493 7.75063 8.38327 7.7173H8.42493C10.8999 7.80896 11.5749 8.55063 11.5499 8.70896L11.4083 9.38396L11.1666 10.4673C11.1666 10.5006 11.1416 10.5506 11.1416 10.5506V10.5673C11.1374 10.5798 11.1291 10.5923 11.1208 10.6048C11.1124 10.6173 11.1041 10.6298 11.0999 10.6423C11.0666 10.7506 11.0166 10.8506 10.9583 10.9423C10.9541 10.9465 10.9499 10.9527 10.9458 10.959C10.9416 10.9652 10.9374 10.9715 10.9333 10.9756C10.6333 11.4256 10.1249 11.7173 9.55827 11.7173Z"
        fill={fill || '#7E8A96'}
      />
    </svg>
  );
};

export default BoosterSeatIcon;
